import { render, staticRenderFns } from "./SocialApp.vue?vue&type=template&id=af09f520&"
import script from "./SocialApp.vue?vue&type=script&lang=js&"
export * from "./SocialApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lili/Sites/southern-highlands.com.au-2018/web/app/themes/wisdom/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('af09f520', component.options)
    } else {
      api.reload('af09f520', component.options)
    }
    module.hot.accept("./SocialApp.vue?vue&type=template&id=af09f520&", function () {
      api.rerender('af09f520', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/vue/SocialApp.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/SocialApp.vue
// module id = 122
// module chunks = 7